import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {
  CellsRefinementOptionsEnum,
  RefinementOptionModel,
} from '../../../../models/api/refinementOptionModel';
import {TeammateModel} from '../../../../models/api/teammateModel';
import {DropdownCategory} from '../../../common/dropdowns/dropdownCategory';
import {CellsRefinementOptionsSearchDropdownAssigneeItem} from './cellsRefinementOptionsSearchDropdownAssigneeItem';

/*
 * Props.
 */

interface CellsRefinementOptionsSearchAssigneesDropdownRowProps {
  selectedRefinement: RefinementOptionModel | undefined;
  onSelectAssignee: HandlerOf<TeammateModel>;
  isNotInteractive: boolean;
  assignee: TeammateModel | null;
}

/*
 * Component.
 */

export const CellsRefinementOptionsSearchAssigneesDropdownRow: FC<
  CellsRefinementOptionsSearchAssigneesDropdownRowProps
> = (props) => {
  const {onSelectAssignee, selectedRefinement, isNotInteractive, assignee} = props;

  if (assignee === null) {
    return (
      <DropdownCategory>
        <Trans id="cells-refinement-options-search-assignees-dropdown-category">All assignees</Trans>
      </DropdownCategory>
    );
  }

  const isChecked =
    selectedRefinement !== undefined &&
    selectedRefinement.type === CellsRefinementOptionsEnum.ASSIGNEE &&
    selectedRefinement.id === assignee.id;

  return (
    <CellsRefinementOptionsSearchDropdownAssigneeItem
      key={assignee.id}
      teammate={assignee}
      isChecked={isChecked}
      isNotInteractive={isNotInteractive}
      onSelect={() => {
        onSelectAssignee(assignee);
      }}
    />
  );
};
